<template>
  <DashboardTemplate :navMenu="false" class="profile-detail">
    <div
      class="flex-display js-between ai-center pd-b-3 disabled-on-print flex-warp"
    >
      <div class="text-left">
        <h3 class="mg-y-less text-font-24">
          ข้อมูลส่วนตัว
          <span
            v-if="!haveUserData && user.role == 0"
            class="color-gray text-font-18"
            >(กรุณากรอกข้อมูลเพื่อเริ่มใช้งานระบบ)</span
          >
        </h3>
      </div>

      <div class="width-100 text-right">
        <el-popconfirm
          @onConfirm="deleteAccount"
          confirm-button-text="ลบ"
          cancel-button-text="ยกเลิก"
          icon="el-icon-info"
          icon-color="red"
          confirm-button-type="danger"
          title="คุณแน่ใจใช่ไหมที่จะลบบัญชีของคุณ?"
        >
          <span slot="reference" class="del-account"
            ><i class="fas fa-trash"></i> ลบบัญชี</span
          >
        </el-popconfirm>
      </div>
    </div>

    <div v-loading="loading" class=" pd-b-print-less">
      <div class="flex-display mobile-display js-between mg-b-3">
        <div class="pd-y-3 disabled-on-print out-box-image  pd-x-4">
          <el-upload
            action="#"
            class="box-image-upload-profile"
            ref="upload"
            list-type="picture-card"
            :auto-upload="false"
            :on-change="uploadImage"
          >
            <div class="preview">
              <avatar
                v-if="personal.profileImg || user.profileFrom"
                :rounded="false"
                :username="personal.nameTh"
                :class="{
                  facebook:
                    user.from == 'faceBook' && personal.profileImg == '',
                }"
                :src="
                  personal.profileImg
                    ? `${urlImage}${user.userId}/${personal.profileImg}`
                    : user.from == 'faceBook' && personal.profileImg == ''
                    ? `https://graph.facebook.com/${user.profileFrom}/picture?type=large`
                    : `${user.profileFrom}`
                "
                :size="160"
                class="set-img"
              ></avatar>
              <avatar
                v-else
                :rounded="false"
                :username="personal.nameTh"
                :src="``"
                :size="160"
                class="set-img"
              ></avatar>
              <span class="icon">
                <i class="fas fa-1x fa-camera"></i>
              </span>
            </div>
          </el-upload>
        </div>
        <div class="view-box">
          <div class="pd-b-2 pd-b-print-3">
            <div class="flex-display js-between ai-center border-b mg-b-3">
              <h4 class="mg-y-4 text-font-18">ข้อมูลส่วนบุคคล</h4>
              <a
                @click="showInputPersonal = true"
                class="text-font-12 color-primary-light disabled-on-print"
              >
                <i class="fas fa-pen"></i> แก้ไขข้อมูล
              </a>
            </div>
            <ProfilePersonalInfoForm
              v-if="showInputPersonal"
              from="profile"
              :value="personal"
              @setFormStep="(data) => saveProfile(data, 'personal')"
            />
            <ProfilePersonalInfoView
              v-else
              :prefix="personal.prefix"
              :nameTh="personal.nameTh"
              :lastNameTh="personal.lastNameTh"
              :nameEn="personal.nameEn"
              :lastNameEn="personal.lastNameEn"
              :phoneNumber="personal.phoneNumberObj.formatNational"
              :idCard="personal.idCard"
              :birthDay="personal.birthDay"
              :position="personal.position"
              :address="personal.address"
              :subDistrict="personal.subDistrict"
              :district="personal.district"
              :province="personal.province"
              :postcode="personal.postcode"
            />
          </div>
          <div class="pd-b-2 pd-b-print-less">
            <div class="flex-display js-between ai-center border-b mg-b-3">
              <h4 class="mg-y-4 text-font-18">ข้อมูลบริษัท</h4>
              <a
                @click="showInputCompany = true"
                class="text-font-12 color-primary-light disabled-on-print"
              >
                <i class="fas fa-pen"></i> แก้ไขข้อมูล
              </a>
            </div>

            <ProfileCompanyForm
              v-if="showInputCompany"
              from="profile"
              :value="company"
              @setFormStep="(data) => saveProfile(data, 'company')"
            />
            <ProfileCompanyView
              v-else
              from="profile"
              :agency="company.agency"
              :agencyType="company.agencyType"
              :etc="company.etc"
              :address="company.address"
              :subDistrict="company.subDistrict"
              :district="company.district"
              :province="company.province"
              :postcode="company.postcode"
            />
          </div>
        </div>
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ProfilePersonalInfoView from "@/components/profile/ProfilePersonalInfoView";
import ProfileCompanyView from "@/components/profile/ProfileCompanyView";
import Avatar from "vue-avatar";
import ProfilePersonalInfoForm from "@/components/profile/ProfilePersonalInfoForm";
import ProfileCompanyForm from "@/components/profile/ProfileCompanyForm";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    ProfilePersonalInfoView,
    ProfileCompanyView,
    Avatar,
    ProfilePersonalInfoForm,
    ProfileCompanyForm,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
    prefixList() {
      return this.$store.state.prefixList;
    },
    haveUserData() {
      return this.$store.state.haveUserData;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  data() {
    return {
      showEdit: true,
      personal: {
        profileImg: "",
        prefix: null,
        nameTh: "",
        lastNameTh: "",
        nameEn: "",
        lastNameEn: "",
        idCard: "",
        birthDay: "",
        position: "",
        address: "",
        subDistrict: "",
        district: "",
        province: "",
        postcode: "",
        phoneNumberObj: {
          countryCode: "",
          formatNational: "",
          numberValid: true,
        },
      },
      company: {
        agency: "",
        agencyType: null,
        etc: "",
        address: "",
        subDistrict: "",
        district: "",
        province: "",
        postcode: "",
      },
      showInputPersonal: false,
      showInputCompany: false,
      urlImage: process.env.VUE_APP_BASE_URL_IMAGE,
      loading: true,
      courseStatus: 0,
      courseId: "",
    };
  },
  mounted() {
    this.fetchStudentsById();
    this.fetchCourseStatus();
    this.fetchCourseList();
    if (!this.haveUserData && this.user.role == 0) {
      this.showInputPersonal = true;
      this.showInputCompany = true;
    }
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);

      if (this.courseList.length > 0) {
        this.courseId = this.courseList[0]._id;
      }
    },
    fetchCourseStatus() {
      let obj = {
        _id: this.user.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`status/course`, obj).then((res) => {
        if (res.data.success) {
          let pending = res.data.obj.pending.filter(
            (filter) => filter.courseId == this.courseId
          );

          let approved = res.data.obj.approved.filter(
            (filter) => filter.courseId == this.courseId
          );

          let disapproval = res.data.obj.disapproval.filter(
            (filter) => filter.courseId == this.courseId
          );

          if (pending.length > 0) {
            this.courseStatus = 2;
          }

          if (approved.length > 0) {
            this.courseStatus = 1;
          }

          if (disapproval.length > 0) {
            this.courseStatus = 3;
          }
        }
      });
    },
    uploadImage(file) {
      this.loading = true;

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();

      formData.append("userId", this.user.userId);
      formData.append("img", file.raw);
      formData.append("delFile", this.personal.profileImg);

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`update/profile/img`, formData, config)
        .then((res) => {
          if (res.data.success) {
            this.fetchStudentsById();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("uploadImage error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchStudentsById(type) {
      let obj = {
        _id: this.user.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student`, obj)
        .then((res) => {
          if (res.data.success) {
            if (typeof type === "undefined" || type == "personal") {
              this.personal = {
                profileImg: res.data.obj.profileImg,
                prefix: res.data.obj.titleName,
                nameTh: res.data.obj.nameTH,
                lastNameTh: res.data.obj.surnameTH,
                nameEn: res.data.obj.nameEN,
                lastNameEn: res.data.obj.surnameEN,
                idCard: res.data.obj.identification,
                birthDay: res.data.obj.birthday,
                position: res.data.obj.position,
                address: res.data.obj.address,
                subDistrict: res.data.obj.subdistrict,
                district: res.data.obj.district,
                province: res.data.obj.province,
                postcode: res.data.obj.postcode,
                phoneNumberObj: {
                  countryCode: res.data.obj.countryCode,
                  formatNational: res.data.obj.mobilephone,
                  numberValid: true,
                },
              };
            }

            if (
              (typeof type === "undefined" || type == "company") &&
              typeof res.data.obj.institution != "undefined"
            ) {
              this.company = {
                agency: res.data.obj.institution.name,
                agencyType: res.data.obj.institution.type,
                etc:
                  typeof res.data.obj.institution.etc != "undefined"
                    ? res.data.obj.institution.etc
                    : "",
                address: res.data.obj.institution.address,
                subDistrict:
                  typeof res.data.obj.institution.subdistrict != "undefined"
                    ? res.data.obj.institution.subdistrict
                    : "",
                district: res.data.obj.institution.district,
                province: res.data.obj.institution.province,
                postcode: res.data.obj.institution.postcode,
              };
            }

            let user = {
              email: res.data.obj.email,
              profileImg: res.data.obj.profileImg,
              profileFrom: res.data.obj.profileFrom,
              role: res.data.obj.role,
              userId: res.data.obj._id,
              titleName: res.data.obj.titleName,
              nameTH: res.data.obj.nameTH,
              surnameTH: res.data.obj.surnameTH,
              from: res.data.obj.from,
            };

            if (
              res.data.obj.nameEN &&
              typeof res.data.obj.institution != "undefined" &&
              res.data.obj.institution.name
            ) {
              if (
                !this.haveUserData &&
                this.user.role == 0 &&
                this.courseStatus == 0
              ) {
                this.$router.push(`/course/detail?courseId=${this.courseId}`);
              }
              this.$store.commit("SET_HAVE_USER_DATA", true);
            } else {
              this.$store.commit("SET_HAVE_USER_DATA", false);
            }

            this.$store.commit("SET_USER", user);
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchStudentsById error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    getPrefixLabel(id) {
      let filter = this.prefixList.filter((filter) => filter.id == id);
      if (filter.length > 0) {
        return filter[0].label;
      }
    },
    saveProfile(data, type) {
      this.loading = true;

      let obj = {
        _id: this.user.userId,
        titleName: type == "personal" ? data.prefix : this.personal.prefix,
        nameTH: type == "personal" ? data.nameTh : this.personal.nameTh,
        surnameTH:
          type == "personal" ? data.lastNameTh : this.personal.lastNameTh,
        nameEN: type == "personal" ? data.nameEn : this.personal.nameEn,
        surnameEN:
          type == "personal" ? data.lastNameEn : this.personal.lastNameEn,
        mobilephone:
          type == "personal"
            ? data.phoneNumber
            : this.personal.phoneNumberObj.formatNational,
        identification: type == "personal" ? data.idCard : this.personal.idCard,
        birthday: type == "personal" ? data.birthDay : this.personal.birthDay,
        position: type == "personal" ? data.position : this.personal.position,
        address: type == "personal" ? data.address : this.personal.address,
        postcode: type == "personal" ? data.postcode : this.personal.postcode,
        subdistrict:
          type == "personal" ? data.subDistrict : this.personal.subDistrict,
        district: type == "personal" ? data.district : this.personal.district,
        province: type == "personal" ? data.province : this.personal.province,
        institution: {
          name: type == "company" ? data.agency : this.company.agency,
          type: type == "company" ? data.agencyType : this.company.agencyType,
          etc: type == "company" ? data.etc : this.company.etc,
          address: type == "company" ? data.address : this.company.address,
          postcode: type == "company" ? data.postcode : this.company.postcode,
          subdistrict:
            type == "company" ? data.subDistrict : this.company.subDistrict,
          district: type == "company" ? data.district : this.company.district,
          province: type == "company" ? data.province : this.company.province,
        },
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`student`, obj)
        .then((res) => {
          if (res.data.success) {
            if (type == "personal") {
              this.showInputPersonal = false;
            }

            if (type == "company") {
              this.showInputCompany = false;
            }

            this.fetchStudentsById(type);
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("saveProfile error", e);
        });
    },
    deleteAccount() {
      this.loading = true;

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.delete(`account`)
        .then((res) => {
          if (res.data.success) {
            this.$message("บัญชีและข้อมูลของคุณถูกลบเรียบร้อยแล้ว");
            setTimeout(() => {
              this.$store.commit("SIGNOUT");
              this.$router.push({ path: "/" }).catch(() => {
                window.location.reload();
              });
            }, 2000);
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("saveProfile error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    print() {
      window.print();
    },
  },
};
</script>

<style scoped>
.view-box {
  padding-right: 200px;
  padding-left: 20px;
}
@media (max-width: 1199.98px) {
  .view-box {
    padding: 0 15px;
  }
}
@media (max-width: 991.98px) {
  .view-box {
    padding: 0 15px;
  }
}
.circle-print {
  width: 45px;
  height: 45px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
</style>
